var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { 'loading-bg' : _vm.type == 'absolute' && _vm.loading } ],on:{"click":_vm.eventStopChk}},[_c('clip-loader',{class:{ 'lds-facebook' : _vm.type == 'absolute'},attrs:{"loading":_vm.loading,"color":_vm.color,"size":_vm.size,"width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }